import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import ColumnEnum from '@/global/components/DataGrid/utils/columEnum'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { StatusCompetencia as Status } from '@acme/core'
import dayjs from 'dayjs'
import { InfoIcon } from 'lucide-react'
import { StatusCompetencia } from '../atoms/status'

export function getColumns(tipo: Status): GridColDefPro[] {
    return [
        {
            field: 'responsavel',
            headerName: 'Responsável',
            flex: 1,
            valueGetter: ({
                row: {
                    Usuario: { email },
                },
            }) => email,
        },
        {
            field: 'createdAt',
            headerName: `Momento d${tipo === 'ABERTA' ? 'a abertura' : 'o fechamento'}`,
            width: 220,
            type: 'datetime-local',
            valueFormatter: ({ value }) =>
                dayjs
                    .utc(value)
                    .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                    .format('DD/MM/YYYY HH:mm (z)'),
        },
        {
            field: 'competencia',
            headerName: 'Competência',
            align: 'center',
            width: 150,
            valueGetter: ({ value }) => {
                const [ano, mes] = String(value).split('-').map(Number)
                return dayjs()
                    .set('year', ano)
                    .set('month', mes)
                    .format('MM/YYYY (MMMM)')
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            align: 'center',
            width: 125,
            type: new ColumnEnum([
                { value: 'ABERTA', label: 'Aberta' },
                { value: 'FECHADA', label: 'Fechada' },
            ]),
            renderCell: StatusCompetencia,
        },
        {
            ...optionsColumn,
            field: '__detalhes',
            renderCell: ({ id }) => (
                <IconButton title="Detalhes" href={`${id}/detalhes`}>
                    <InfoIcon />
                </IconButton>
            ),
        },
    ] satisfies GridColDefPro[]
}
